export default __webpack_public_path__ + "static/media/Product_Card_Icon.6391b56a.svg";